import Scroll from './scroll'

class Toc {
    constructor (el, args = {}) {
        this.el = el
        this.waypointEnabled = args.waypoint || false
        this.lastScrollPosition = 0
        this.scrollDirection = 'down'

        this.navItems = Array.from(this.el.querySelectorAll('li span'))

        this.navItems.forEach(item => {
            item.addEventListener('click', this.onClick.bind(this))
        })
 
        this.headings = Array.from(document.querySelectorAll('h1,h2,h3,h4,h5,h6')).filter(el => {
            return this.navItems.some(i => this.getHtml(i) === this.getHtml(el))
        })

        if (this.waypointEnabled) {
            
            this.currentHeading = this.headings.length ? this.headings[0] : null
            window.addEventListener('scroll', this.onScroll.bind(this))
            // let options = {
            //     rootMargin: '0px',
            //     threshold: 1.0,
            // }
              
            // this.previousY = 0
            // this.previousRatio = 0

            // this.observer = new IntersectionObserver(this.observerCallback, options)
            // this.headings.map(h => this.observer.observe(h))
        }

        if (window.location.hash) {
            const html = window.location.hash.substring(1).replace(/\_/g, ' ')
            document.addEventListener('readystatechange', event => {
                if (event.target.readyState === 'complete') {
                    this.scrollToByNavItem(this.findNavItemByHtml(html))
                }
            })
        }
    }

    onScroll () {
        this.scrollDirection = this.lastScrollPosition > window.scrollY ? 'up' : 'down'
        this.lastScrollPosition = window.scrollY
        const windowHeight = window.innerHeight || document.documentElement.clientHeight
  
        if (this.scrollDirection === 'up') {
            const headingScrolledOutIndex = this.headings.findIndex(h => {
                const bounding = h.getBoundingClientRect()
                if (
                    bounding.top >= 0 &&
                    bounding.bottom < windowHeight &&
                    bounding.bottom > windowHeight / 2
                ) {
                    return true
                } else {
                    return false
                }
            })

            if (headingScrolledOutIndex > 0) {
                this.setActiveHeading(this.headings[headingScrolledOutIndex - 1])
            }
        } else {
            const headingInView = this.headings.find(h => {
                const bounding = h.getBoundingClientRect()
                if (
                    bounding.top >= 0 &&
                    bounding.bottom <= windowHeight / 2
                ) {
                    return true
                } else {
                    return false
                }
            })
    
            if (headingInView) {
                this.setActiveHeading(headingInView)
            } else {
                let closesHeading = null
                let closesHeadingBottomBound = null
                this.headings.forEach(h => {
                    const bounding = h.getBoundingClientRect()
                    if (bounding.bottom < 0) {
                        if (!closesHeading) {
                            closesHeading = h
                            closesHeadingBottomBound = bounding.bottom
                        } else if (bounding.bottom > closesHeadingBottomBound) {
                            closesHeading = h
                            closesHeadingBottomBound = bounding.bottom
                        }
                    }
                })
                if (closesHeading) {
                    this.setActiveHeading(closesHeading)
                }
            }
        }
    }

    onClick (e) {
        const el = e.target
        this.scrollToByNavItem(e.target)
    }

    findHeading (el) {
        return this.headings.find(h => this.getHtml(h) === this.getHtml(el))
    }

    findNavItem (el) {
        return this.navItems.find(h => this.getHtml(h) === this.getHtml(el))
    }

    findNavItemByHtml (html) {
        return this.navItems.find(h => this.getHtml(h) === html)
    }

    setActiveHeading (el) {
        const navItem = this.findNavItemByHtml(this.getHtml(el))
        if (navItem && !navItem.classList.contains('-active')) {
            this.navItems.map(e => e.classList.remove('-active'))
            navItem.classList.add('-active')
        }
    }

    scrollToByNavItem (navItem) {
        const el = this.findHeading(navItem)
        const fixed = navItem.closest('.js-sticky')
        const offset = fixed ? fixed.offsetHeight * -1 : 0
        if (el) {
            Scroll.scrollToEl(el, { offset })
            location.hash = '#' + this.getHtml(navItem).replace(/\s+/g, '_')
        }
    }

    observerCallback (entries, observer) {
        entries.forEach(entry => {
          
            const currentY = entry.boundingClientRect.y
            const currentRatio = entry.intersectionRatio
            const isIntersecting = entry.isIntersecting
 
            // Scrolling down/up
            if (currentY < this.previousY) {
                if (currentRatio > this.previousRatio && isIntersecting) {
                    console.log('Scrolling down enter')
                } else {
                    console.log('Scrolling down leave')
                }
            } else if (currentY > this.previousY && isIntersecting) {
                if (currentRatio < this.previousRatio) {
                    console.log('Scrolling up leave')
                } else {
                    console.log('Scrolling up enter')
                }
            }
            this.previousY = currentY
            this.previousRatio = currentRatio
        })
    }

    initWaypoint (el) {
        const heading = this.findHeading(el)
        if (heading) {
            new Waypoint({
                element: heading,
                handler: (direction) =>  {
                    this.handleWaypointEnter(el, heading, direction)
                },
            })
            let nextElement = heading.nextElementSibling
            while (nextElement) {
                if (this.headings.some(h => h === nextElement)) {
                    break
                }
                new Waypoint({
                    element: nextElement,
                    handler: (direction) =>  {
                        this.handleWaypointEnter(el, nextElement, direction)
                    },
                })
                nextElement = nextElement.nextElementSibling
            }
        }
    }

    handleWaypointEnter (el, heading, direction) {
        this.navItems.forEach(el => {
            el.classList.remove('-active')
        })
        el.classList.add('-active')
    }
    
    getHtml (el) {
        return this.stripTags(el.innerHTML)
    }

    stripTags (string) {
        return string.replace(/(<([^>]+)>)/gi, '').replace(/\r?\n|\r/gi, ' ')
    }
}
export default Toc